"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getListenerType = exports.ifRandom = void 0;
const types_1 = require("@framework/types");
const ifRandom = (contractFeatures) => {
    if (contractFeatures.includes(types_1.ContractFeatures.RANDOM) || contractFeatures.includes(types_1.ContractFeatures.GENES)) {
        return "RANDOM";
    }
    else {
        return "COMMON";
    }
};
exports.ifRandom = ifRandom;
const getListenerType = (contract) => {
    const { contractType, contractModule, contractFeatures } = contract;
    switch (contractModule) {
        case types_1.ModuleType.COLLECTION:
            return types_1.ListenerType.COLLECTION;
        case types_1.ModuleType.MYSTERY:
            return types_1.ListenerType.MYSTERY;
        case types_1.ModuleType.LOOT:
            return types_1.ListenerType.LOOT;
        case types_1.ModuleType.VESTING:
            return types_1.ListenerType.VESTING;
        case types_1.ModuleType.STAKING:
            return types_1.ListenerType.STAKING;
        case types_1.ModuleType.PONZI:
            return types_1.ListenerType.PONZI;
        case types_1.ModuleType.PREDICTION:
            return types_1.ListenerType.PREDICTION;
        case types_1.ModuleType.WAIT_LIST:
            return types_1.ListenerType.WAIT_LIST;
        case types_1.ModuleType.LOTTERY:
            switch (contractType) {
                case types_1.TokenType.ERC721:
                    return types_1.ListenerType.LOTTERY_TICKET;
                default:
                    return types_1.ListenerType.LOTTERY;
            }
        case types_1.ModuleType.RAFFLE:
            switch (contractType) {
                case types_1.TokenType.ERC721:
                    return types_1.ListenerType.RAFFLE_TICKET;
                default:
                    return types_1.ListenerType.RAFFLE;
            }
        case types_1.ModuleType.HIERARCHY:
            switch (contractType) {
                case types_1.TokenType.ERC20:
                    return types_1.ListenerType.ERC20;
                case types_1.TokenType.ERC1155:
                    return types_1.ListenerType.ERC1155;
                case types_1.TokenType.ERC721:
                    switch ((0, exports.ifRandom)(contractFeatures)) {
                        case "COMMON":
                            return types_1.ListenerType.ERC721;
                        case "RANDOM":
                            return types_1.ListenerType.ERC721_RANDOM;
                        default: // Should never happen
                            return types_1.ListenerType.ERC721;
                    }
                case types_1.TokenType.ERC998:
                    switch ((0, exports.ifRandom)(contractFeatures)) {
                        case "COMMON":
                            return types_1.ListenerType.ERC998;
                        case "RANDOM":
                            return types_1.ListenerType.ERC998_RANDOM;
                        default: // Should never happen
                            return types_1.ListenerType.ERC998;
                    }
                default: // NATIVE
                    throw new Error("wrong listener type: NATIVE");
            }
        default:
            throw new Error("wrong listener type");
    }
};
exports.getListenerType = getListenerType;
//# sourceMappingURL=listener-type.js.map